export default __webpack_public_path__ + "static/media/icon2.da5bc63e.png";